/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import DragLineDataset from '../../dataset/dragline';
import DragArea from '../dragarea';
/**
 * API class of dragcolumn inheriting from area class
 */
class DragLine extends DragArea {
  constructor () {
    super();
    this.defaultPlotShadow = 1;
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'DragLine';
  }
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'DragLine';
  }

  /**
   * Function to parse chart specific configurations. It first calls the __setDefaultConfig of areabase class.
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    var config = this.config;
    config.isDrag = true;
    config.zeroplanethickness = 1;
    config.zeroplanealpha = 40;
    config.showzeroplaneontop = 0;
    config.enablemousetracking = true;
    config.defaultcrosslinethickness = 1;
  }
  /**
   * Function to return the dataset liked with the current API
   * @return {Object} The DragLineDataset class
   */
  getDSdef () {
    return DragLineDataset;
  }
}
export default DragLine;
